import Vue from "vue"
import ProductsInfo from "./products-details"
import Loading from '@/components/widgets/Loading.vue'
import SortedTablePlugin from "vue-sorted-table"
import CreateMiscellaneous from './products-create'
import AddStock from './add-stock'
import IssueStock from './issue-stock'

import Paginate from "@/components/widgets/pagination.vue";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    Loading,
    ProductsInfo,
    Paginate,
    CreateMiscellaneous,
    AddStock,
    IssueStock
  },
  data() {
    return {
      role: "",
      branch: "",
      loading: false,
      busy: false,
      sortBy: 'created_at',
      lowStockOnly: false,
      apiStatus: 'ไม่พบข้อมูล',
      totalItem: 0,
      currentPage: 1,
      currentData: {},
      perPage: 8,
      sortDesc: true,
      keyword: '',
      create: {
        Id: null,
        mode: 'create',
        state: false
      },
      issue: {
        state: false
      },
      summary: {
        item_count: 0,
        total_qty: 0,
        total_value: 0,
        low_stock_count: 0,
      },
      fields: [
        {
          key: "code",
          label: "รหัส",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "sku.main_product.name",
          label: "ประเภท",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "name",
          label: "ชื่อสินค้า",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "qualtity",
          label: "จำนวน",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-xs-1/2 font-weight-bold text-black",
          sortable: true,
        },
        {
          key: "min_stock",
          label: "จุดสั่งซื้อ",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "unit_name",
          label: "หน่วยนับ",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "average_cost",
          label: "ต้นทุนเฉลี่ย",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "price",
          label: "ราคาขาย",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "status",
          label: "สถานะ",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: true,
        },
        {
          key: "note",
          label: "หมายเหตุ",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
        },
        {
          key: 'action',
          label: '#',
          thClass: 'font-weight-bold text-xs-1/2',
          class: 'text-gray-400 text-right text-xs-1/2'
        }
      ],
      items: [],

      // =========================
      // ประวัติสต็อก (Popup)
      // =========================
      historyOpened: false,
      historyLoading: false,
      historyItems: [],
      historyPagination: {
        current_page: 1,
        last_page: 1,
      },
      historyTargetId: null,
      historyTab: 'history',
      lotsLoading: false,
      lotsOnlyRemaining: true,
      lotData: { item: null, lots: [], totals: {} },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onInitData(1)
    })
    this.getRole()
  },
  computed: {
    rows() {
      return this.items.length
    },
    canSeeSummary() {
      return this.role === 'Admin' || this.role === 'Branch Admin' || this.role === 'Account manager'
    },
    // Admin (ผู้ดูแลระบบ ไม่มีสาขา) ดูได้อย่างเดียว แก้ไขสต็อกสาขาไม่ได้
    isReadOnly() {
      return this.role === 'Admin'
    }
  },
  methods: {
    async getRole() {
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res?.data.role
      this.branch = res?.data.branch_id
      this.fetchSummary()
    },
    onCreate() {
      this.create.Id = null
      this.create.mode = 'create'
      this.create.state = !this.create.state
    },
    onUpdate(id) {
      this.create.Id = id
      this.create.mode = 'update'
      this.create.state = !this.create.state
    },
    onCreateClose(data) {
      if (data.status) {
        this.create.state = false
        setTimeout(() => {
          const currentPage = this.currentPage
          this.onInitData(currentPage)
        }, 500)
      }
    },
    onIssue() {
      this.issue.state = !this.issue.state
    },
    onIssueClose(data) {
      this.issue.state = false
      if (data && data.status) {
        setTimeout(() => {
          this.onInitData(this.currentPage)
        }, 500)
      }
    },
    async fetchSummary() {
      if (!this.canSeeSummary) return
      try {
        const url = `${Vue.prototype.$host}/api/v1/miscellaneous/summary?isBranchStock=true`
        const res = await Vue.prototype.$axios.get(url)
        if (res && res.data) {
          this.summary = res.data
        }
      } catch (error) {
        // เงียบไว้ ไม่ต้องรบกวนผู้ใช้ถ้าการ์ดสรุปโหลดไม่ได้
        console.error('summary error', error)
      }
    },
    // จำนวนสต็อก: โชว์ทศนิยมเท่าที่มี (สูงสุด 4) — ไม่ปัดเป็นจำนวนเต็ม
    formatQty(value) {
      const n = parseFloat(value) || 0
      return n.toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 4 })
    },
    toggleLowStock() {
      this.lowStockOnly = !this.lowStockOnly
      this.onInitData(1)
    },
    // b-table sort เปลี่ยน -> ยิงหลังบ้านใหม่ (no-local-sorting)
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy || 'created_at'
      this.sortDesc = !!ctx.sortDesc
      this.onInitData(1)
    },
    actionLabel(action) {
      const map = {
        in: 'รับเข้า',
        out: 'นำออก',
        adjust: 'ปรับยอด',
        delete: 'ลบ',
        transfer_in: 'รับโอน',
        transfer_out: 'โอนออก',
      }
      return map[action] || action
    },
    referenceLabel(type, id) {
      if (!type) return '-'
      const map = {
        misc_create: 'รับเข้าเอง',
        misc_withdraw: 'นำออกเอง',
        stock_issue: 'ใบนำออก',
        stock_issue_cancel: 'ยกเลิกใบนำออก',
        delivery: 'ใบส่งสินค้า',
        delivery_edit: 'แก้ไขใบส่งสินค้า',
        delivery_cancel: 'ยกเลิกใบส่งสินค้า',
        purchase_receipt: 'ใบสั่งซื้อ',
        transfer: 'โอนสาขา',
        update: 'แก้ไขรายการ',
        delete: 'ลบรายการ',
        opening: 'ยอดยกมา',
      }
      const label = map[type] || type
      // uuid ยาว ๆ ไม่ช่วยอะไรผู้ใช้ — โชว์เฉพาะเลขเอกสารที่อ่านได้
      const showId = id && String(id).length <= 24 && !/^[0-9a-f]{8}-/.test(String(id))
      return showId ? `${label} ${id}` : label
    },
    formatNumber(value, digits = 0) {
      const n = parseFloat(value) || 0
      return n.toLocaleString('th-TH', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })
    },
    async onInitData(currentPage = 1) {
      try {
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const page = currentPage ? currentPage : 1
        this.currentPage = page

        const params = new URLSearchParams({
          page: String(page),
          keyword: this.keyword || '',
          isBranchStock: 'true',
          sort_by: this.sortBy || 'created_at',
          sort_desc: this.sortDesc ? 'true' : 'false',
          low_stock: this.lowStockOnly ? 'true' : 'false',
        })
        const url = `${Vue.prototype.$host}/api/v1/miscellaneous?${params.toString()}`

        const result = await Vue.prototype.$axios.get(url)
        setTimeout(() => {
          this.apiStatus = 'ไม่พบข้อมูล'
          this.busy = false

          if (result) {
            this.currentData = result.data
            this.items = result.data.data
            this.totalItem = result.data.total
            this.fetchSummary()
          }
        }, 500)
      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },
    async Export() {
      try {
        this.loading = true
        await this.$axios.post(`${Vue.prototype.$host}/api/v1/exportMiscellaneousExcel`, {}, {
          responseType: 'blob'
        }).then((response) => {
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'miscellaneous.xlsx')
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },

    // =========================
    // HISTORY METHODS
    // =========================
    openHistory(uuid) {
      this.historyTargetId = uuid
      this.historyOpened = true
      this.historyTab = 'history'
      this.lotData = { item: null, lots: [], totals: {} }
      this.fetchHistory(uuid, 1)
    },
    switchToLots() {
      this.historyTab = 'lots'
      if (!this.lotData.item && this.historyTargetId) {
        this.fetchLots(this.historyTargetId)
      }
    },
    // lot คงเหลือของรายการ — ต้นทุนรายล็อตไว้ดู มูลค่าจริงใช้ต้นทุนเฉลี่ย
    async fetchLots(uuid) {
      try {
        this.lotsLoading = true
        const url = `${Vue.prototype.$host}/api/v1/miscellaneous/${uuid}/lots?only_remaining=${this.lotsOnlyRemaining ? 'true' : 'false'}`
        const res = await Vue.prototype.$axios.get(url)
        this.lotData = res.data || { item: null, lots: [], totals: {} }
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'ไม่สามารถโหลด lot ได้')
      } finally {
        this.lotsLoading = false
      }
    },
    async fetchHistory(uuid, page = 1) {
      try {
        this.historyLoading = true
        const url = `${Vue.prototype.$host}/api/v1/miscellaneous/${uuid}/history?page=${page}`
        const res = await Vue.prototype.$axios.get(url)

        this.historyLoading = false
        this.historyItems = res.data.data || []
        this.historyPagination.current_page = res.data.current_page
        this.historyPagination.last_page = res.data.last_page
      } catch (error) {
        this.historyLoading = false
        console.error(error)
        this.onExceptionHandler(
          error?.response?.data?.message || 'ไม่สามารถโหลดประวัติได้'
        )
      }
    },
    onHistoryPage(page) {
      if (!this.historyTargetId) return
      if (page < 1 || page > this.historyPagination.last_page) return
      this.fetchHistory(this.historyTargetId, page)
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return new Date(dateStr).toLocaleString('th-TH')
    }
  }
}
